import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { WHATSAPP_LINK, TEL_LINK } from "@/lib/site";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const FloatingWhatsApp = () => {
    return (
        <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 1.2, type: "spring", stiffness: 200, damping: 16 }}
            className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3"
        >
            <a
                data-testid="floating-whatsapp-btn"
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Testar no WhatsApp"
                className="group relative flex items-center gap-2 rounded-full bg-[#25D366] py-3.5 pl-4 pr-4 text-white shadow-[0_0_28px_rgba(37,211,102,0.5)] transition-transform hover:scale-105"
            >
                <WhatsAppIcon className="w-6 h-6 flex-shrink-0" />
                <span className="hidden sm:inline max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-all duration-300 group-hover:max-w-[180px] group-hover:ml-0">
                    Testar no WhatsApp
                </span>
            </a>
            <a
                data-testid="floating-call-btn"
                href={TEL_LINK}
                aria-label="Ligar agora"
                className="group relative flex items-center gap-2 rounded-full bg-[#3B6FFF] py-3.5 pl-4 pr-4 text-white shadow-[0_0_28px_rgba(59,111,255,0.5)] transition-transform hover:scale-105"
            >
                <Phone className="w-6 h-6 flex-shrink-0" />
                <span className="hidden sm:inline max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-all duration-300 group-hover:max-w-[180px]">
                    Ligar agora
                </span>
            </a>
        </motion.div>
    );
};

export default FloatingWhatsApp;
